<template>
    <el-container style="height:89vh;">
      <Sidebar />
      <el-container>
        <el-main>
         <appMain />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import Sidebar from '@/components/AppMainSidebar' // 侧边栏
import appMain from './components/appMain' // 侧边栏

export default {
  name: 'Deparyment',
  components: {
    Sidebar,
    appMain
  }
}
</script>

<style lang="less" scoped>
</style>
